import { Row, Col, Card, Form, Badge } from "react-bootstrap";

function TaskChoiceButtons({ taskId, currentValue, onChoiceChange }) {
  return (
    <div className="btn-group hoewist-task-choice" role="group">
      <button
        type="button"
        className={`btn btn-sm ${currentValue === false ? "btn-danger" : "btn-outline-secondary"}`}
        onClick={() => onChoiceChange(taskId, currentValue === false ? null : false)}
      >
        <i className="far fa-times me-1" />
        Liever niet
      </button>
      <button
        type="button"
        className={`btn btn-sm ${currentValue === true ? "btn-success" : "btn-outline-secondary"}`}
        onClick={() => onChoiceChange(taskId, currentValue === true ? null : true)}
      >
        <i className="far fa-check me-1" />
        Ja, graag
      </button>
    </div>
  );
}

function TaskCard({ task, pref = {}, isNew, onChoiceChange, onCommentChange }) {
  const hasChoice = pref.wantsToDo != null;
  const interested = pref.wantsToDo === true;

  return (
    <Card className={`mb-2 hoewist-task-card ${hasChoice ? "border-success" : "border-warning"}`}>
      <Card.Body className="py-2">
        <Row className="align-items-center g-2">
          <Col md={4}>
            <strong className="hoewist-task-name">{task.name}</strong>
            <div className="mt-1">
              {(task.programmes || []).map(p => (
                <Badge key={p.ID ?? p.programmeID} bg="primary" className="me-1">
                  {p.name}
                </Badge>
              ))}
              {task.educationalActivity && (
                <Badge bg="light" text="dark">Onderwijsactiviteit</Badge>
              )}
            </div>
          </Col>

          <Col md={8} className="d-flex align-items-center">
            {isNew ? (
              <Form.Check
                type="checkbox"
                id={`task-interest-${task.ID}`}
                label={
                  <span className="hoewist-not-capable-label">Ik heb interesse</span>
                }
                checked={interested}
                onChange={e =>
                  onChoiceChange(task.ID, e.target.checked ? true : null)
                }
              />
            ) : (
              <TaskChoiceButtons
                taskId={task.ID}
                currentValue={hasChoice ? pref.wantsToDo : null}
                onChoiceChange={onChoiceChange}
              />
            )}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="Opmerking (optioneel)"
              value={pref.comment ?? ""}
              onChange={e => onCommentChange(task.ID, e.target.value)}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default TaskCard;
